/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Outside_ReceiptInputs */

const en_scene_outside_receipt = /** @type {(inputs: Scene_Outside_ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receipt`)
};

/**
* | output |
* | --- |
* | "Receipt" |
*
* @param {Scene_Outside_ReceiptInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_outside_receipt = /** @type {((inputs?: Scene_Outside_ReceiptInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Outside_ReceiptInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_outside_receipt(inputs)
});